module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/pui-react-back-to-top/~/pui-react-animation/~/babel-runtime/~/core-js/library/modules/$.library.js
 ** module id = 298
 ** module chunks = 0
 **/